"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BR = void 0;
exports.BR = {
    numericCode: '076',
    alpha2Code: 'BR',
    alpha3Code: 'BRA',
    englishName: {
        short: 'Brazil',
        full: 'the Federative Republic of Brazil',
    },
    names: {
        full: {
            en: 'the Federative Republic of Brazil',
            fr: 'la République fédérative du Brésil',
            pt: 'Brasil (o)',
        },
        short: {
            en: 'Brazil',
            fr: 'Brésil (le)',
            pt: 'Brasil (o)',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'pt',
            languageAlpha3Code: 'por',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'BR-AC': {
            numericCode: '076',
            code: 'BR-AC',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Acre',
            },
        },
        'BR-AL': {
            numericCode: '076',
            code: 'BR-AL',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Alagoas',
            },
        },
        'BR-AM': {
            numericCode: '076',
            code: 'BR-AM',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Amazonas',
            },
        },
        'BR-AP': {
            numericCode: '076',
            code: 'BR-AP',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Amapá',
            },
        },
        'BR-BA': {
            numericCode: '076',
            code: 'BR-BA',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Bahia',
            },
        },
        'BR-CE': {
            numericCode: '076',
            code: 'BR-CE',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Ceará',
            },
        },
        'BR-ES': {
            numericCode: '076',
            code: 'BR-ES',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Espírito Santo',
            },
        },
        'BR-GO': {
            numericCode: '076',
            code: 'BR-GO',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Goiás',
            },
        },
        'BR-MA': {
            numericCode: '076',
            code: 'BR-MA',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Maranhão',
            },
        },
        'BR-MG': {
            numericCode: '076',
            code: 'BR-MG',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Minas Gerais',
            },
        },
        'BR-MS': {
            numericCode: '076',
            code: 'BR-MS',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Mato Grosso do Sul',
            },
        },
        'BR-MT': {
            numericCode: '076',
            code: 'BR-MT',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Mato Grosso',
            },
        },
        'BR-PA': {
            numericCode: '076',
            code: 'BR-PA',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Pará',
            },
        },
        'BR-PB': {
            numericCode: '076',
            code: 'BR-PB',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Paraíba',
            },
        },
        'BR-PE': {
            numericCode: '076',
            code: 'BR-PE',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Pernambuco',
            },
        },
        'BR-PI': {
            numericCode: '076',
            code: 'BR-PI',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Piauí',
            },
        },
        'BR-PR': {
            numericCode: '076',
            code: 'BR-PR',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Paraná',
            },
        },
        'BR-RJ': {
            numericCode: '076',
            code: 'BR-RJ',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Rio de Janeiro',
            },
        },
        'BR-RN': {
            numericCode: '076',
            code: 'BR-RN',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Rio Grande do Norte',
            },
        },
        'BR-RO': {
            numericCode: '076',
            code: 'BR-RO',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Rondônia',
            },
        },
        'BR-RR': {
            numericCode: '076',
            code: 'BR-RR',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Roraima',
            },
        },
        'BR-RS': {
            numericCode: '076',
            code: 'BR-RS',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Rio Grande do Sul',
            },
        },
        'BR-SC': {
            numericCode: '076',
            code: 'BR-SC',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Santa Catarina',
            },
        },
        'BR-SE': {
            numericCode: '076',
            code: 'BR-SE',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Sergipe',
            },
        },
        'BR-SP': {
            numericCode: '076',
            code: 'BR-SP',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'São Paulo',
            },
        },
        'BR-TO': {
            numericCode: '076',
            code: 'BR-TO',
            category: {
                id: '193',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                    pt: {
                        singular: 'estado',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Tocantins',
            },
        },
        'BR-DF': {
            numericCode: '076',
            code: 'BR-DF',
            category: {
                id: '403',
                names: {
                    en: {
                        singular: 'federal district',
                        plural: 'federal districts',
                    },
                    fr: {
                        singular: 'district fédéral',
                        plural: '',
                    },
                    pt: {
                        singular: 'distrito federal',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                pt: 'Distrito Federal',
            },
        },
    },
    cities: [
        {
            name: 'Vitória do Mearim',
            subdivision: 'Maranhão',
        },
        {
            name: 'Vitória de Santo Antão',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Viseu',
            subdivision: 'Pará',
        },
        {
            name: 'Conde',
            subdivision: 'Paraíba',
        },
        {
            name: 'Vigia',
            subdivision: 'Pará',
        },
        {
            name: 'Viçosa do Ceará',
            subdivision: 'Ceará',
        },
        {
            name: 'Viçosa',
            subdivision: 'Alagoas',
        },
        {
            name: 'Viana',
            subdivision: 'Maranhão',
        },
        {
            name: 'Várzea Alegre',
            subdivision: 'Ceará',
        },
        {
            name: 'Varjota',
            subdivision: 'Ceará',
        },
        {
            name: 'Vargem Grande',
            subdivision: 'Maranhão',
        },
        {
            name: 'Valença do Piauí',
            subdivision: 'Piauí',
        },
        {
            name: 'União dos Palmares',
            subdivision: 'Alagoas',
        },
        {
            name: 'União',
            subdivision: 'Piauí',
        },
        {
            name: 'Tuntum',
            subdivision: 'Maranhão',
        },
        {
            name: 'Tucuruí',
            subdivision: 'Pará',
        },
        {
            name: 'Tucumã',
            subdivision: 'Pará',
        },
        {
            name: 'Trindade',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Trairi',
            subdivision: 'Ceará',
        },
        {
            name: 'Toritama',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Tomé Açu',
            subdivision: 'Pará',
        },
        {
            name: 'Timon',
            subdivision: 'Maranhão',
        },
        {
            name: 'Timbiras',
            subdivision: 'Maranhão',
        },
        {
            name: 'Timbaúba',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Tianguá',
            subdivision: 'Ceará',
        },
        {
            name: 'Teresina',
            subdivision: 'Piauí',
        },
        {
            name: 'São João dos Inhamuns',
            subdivision: 'Ceará',
        },
        {
            name: 'Tamandaré',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Tabira',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Surubim',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Sousa',
            subdivision: 'Paraíba',
        },
        {
            name: 'Soure',
            subdivision: 'Pará',
        },
        {
            name: 'Solânea',
            subdivision: 'Paraíba',
        },
        {
            name: 'Sobral',
            subdivision: 'Ceará',
        },
        {
            name: 'Sirinhaém',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Sertânia',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Serra Talhada',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Senador Pompeu',
            subdivision: 'Ceará',
        },
        {
            name: 'Satuba',
            subdivision: 'Alagoas',
        },
        {
            name: 'São Raimundo Nonato',
            subdivision: 'Piauí',
        },
        {
            name: 'São Miguel dos Campos',
            subdivision: 'Alagoas',
        },
        {
            name: 'São Miguel do Guamá',
            subdivision: 'Pará',
        },
        {
            name: 'São Mateus do Maranhão',
            subdivision: 'Maranhão',
        },
        {
            name: 'São Luís do Quitunde',
            subdivision: 'Alagoas',
        },
        {
            name: 'São Luís',
            subdivision: 'Maranhão',
        },
        {
            name: 'São Lourenço da Mata',
            subdivision: 'Pernambuco',
        },
        {
            name: 'São José do Egito',
            subdivision: 'Pernambuco',
        },
        {
            name: 'São José de Ribamar',
            subdivision: 'Maranhão',
        },
        {
            name: 'São José de Mipibu',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'São João dos Patos',
            subdivision: 'Maranhão',
        },
        {
            name: 'São Gonçalo do Amarante',
            subdivision: 'Ceará',
        },
        {
            name: 'São Félix do Xingu',
            subdivision: 'Pará',
        },
        {
            name: 'São Domingos do Maranhão',
            subdivision: 'Maranhão',
        },
        {
            name: 'São Bento',
            subdivision: 'Paraíba',
        },
        {
            name: 'São Bento',
            subdivision: 'Maranhão',
        },
        {
            name: 'Santa Rita',
            subdivision: 'Paraíba',
        },
        {
            name: 'Santarém',
            subdivision: 'Pará',
        },
        {
            name: 'Santa Quitéria do Maranhão',
            subdivision: 'Maranhão',
        },
        {
            name: 'Santa Quitéria',
            subdivision: 'Ceará',
        },
        {
            name: 'Santana do Ipanema',
            subdivision: 'Alagoas',
        },
        {
            name: 'Santa Luzia',
            subdivision: 'Maranhão',
        },
        {
            name: 'Santa Inês',
            subdivision: 'Maranhão',
        },
        {
            name: 'Santa Helena',
            subdivision: 'Maranhão',
        },
        {
            name: 'Santa Cruz do Capibaribe',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Santa Cruz',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Salinópolis',
            subdivision: 'Pará',
        },
        {
            name: 'Salgueiro',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Russas',
            subdivision: 'Ceará',
        },
        {
            name: 'Rio Largo',
            subdivision: 'Alagoas',
        },
        {
            name: 'Rio Formoso',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Ribeirão',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Recife',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Quixeramobim',
            subdivision: 'Ceará',
        },
        {
            name: 'Quixadá',
            subdivision: 'Ceará',
        },
        {
            name: 'Presidente Dutra',
            subdivision: 'Maranhão',
        },
        {
            name: 'Santana',
            subdivision: 'Amapá',
        },
        {
            name: 'Porto Calvo',
            subdivision: 'Alagoas',
        },
        {
            name: 'Portel',
            subdivision: 'Pará',
        },
        {
            name: 'Pombos',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Pombal',
            subdivision: 'Paraíba',
        },
        {
            name: 'Piripiri',
            subdivision: 'Piauí',
        },
        {
            name: 'Piracuruca',
            subdivision: 'Piauí',
        },
        {
            name: 'Pinheiro',
            subdivision: 'Maranhão',
        },
        {
            name: 'Pindaré Mirim',
            subdivision: 'Maranhão',
        },
        {
            name: 'Pilar',
            subdivision: 'Alagoas',
        },
        {
            name: 'Picos',
            subdivision: 'Piauí',
        },
        {
            name: 'Petrolina',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Jatobá',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Pesqueira',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Pentecoste',
            subdivision: 'Ceará',
        },
        {
            name: 'Penalva',
            subdivision: 'Maranhão',
        },
        {
            name: 'Pedro II',
            subdivision: 'Piauí',
        },
        {
            name: 'Pedra Branca',
            subdivision: 'Ceará',
        },
        {
            name: 'Paulo Afonso',
            subdivision: 'Bahia',
        },
        {
            name: 'Paulista',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Patos',
            subdivision: 'Paraíba',
        },
        {
            name: 'Parnamirim',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Parnaíba',
            subdivision: 'Piauí',
        },
        {
            name: 'Parintins',
            subdivision: 'Amazonas',
        },
        {
            name: 'Parelhas',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Paraipaba',
            subdivision: 'Ceará',
        },
        {
            name: 'Paragominas',
            subdivision: 'Pará',
        },
        {
            name: 'Paracuru',
            subdivision: 'Ceará',
        },
        {
            name: 'Palmares',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Pacatuba',
            subdivision: 'Ceará',
        },
        {
            name: 'Pacajus',
            subdivision: 'Ceará',
        },
        {
            name: 'Ouricuri',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Orós',
            subdivision: 'Ceará',
        },
        {
            name: 'Oriximiná',
            subdivision: 'Pará',
        },
        {
            name: 'Olinda',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Oeiras',
            subdivision: 'Piauí',
        },
        {
            name: 'Ábidos',
            subdivision: 'Pará',
        },
        {
            name: 'Nova Russas',
            subdivision: 'Ceará',
        },
        {
            name: 'Nova Cruz',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Nazaré da Mata',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Natal',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Murici',
            subdivision: 'Alagoas',
        },
        {
            name: 'Moreno',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Morada Nova',
            subdivision: 'Ceará',
        },
        {
            name: 'Monteiro',
            subdivision: 'Paraíba',
        },
        {
            name: 'Monte Alegre',
            subdivision: 'Pará',
        },
        {
            name: 'Mombaça',
            subdivision: 'Ceará',
        },
        {
            name: 'Moju',
            subdivision: 'Pará',
        },
        {
            name: 'Mossoró',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Mocajuba',
            subdivision: 'Pará',
        },
        {
            name: 'Maués',
            subdivision: 'Amazonas',
        },
        {
            name: 'Matriz de Camaragibe',
            subdivision: 'Alagoas',
        },
        {
            name: 'Mari',
            subdivision: 'Paraíba',
        },
        {
            name: 'Marechal Deodoro',
            subdivision: 'Alagoas',
        },
        {
            name: 'Maragogi',
            subdivision: 'Alagoas',
        },
        {
            name: 'Maracanaú',
            subdivision: 'Ceará',
        },
        {
            name: 'Marabá',
            subdivision: 'Pará',
        },
        {
            name: 'Mamanguape',
            subdivision: 'Paraíba',
        },
        {
            name: 'Maceió',
            subdivision: 'Alagoas',
        },
        {
            name: 'Macau',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Macapá',
            subdivision: 'Amapá',
        },
        {
            name: 'Macaíba',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Limoeiro do Norte',
            subdivision: 'Ceará',
        },
        {
            name: 'Limoeiro',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Lavras da Mangabeira',
            subdivision: 'Ceará',
        },
        {
            name: 'Lajedo',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Lago da Pedra',
            subdivision: 'Maranhão',
        },
        {
            name: 'Lagoa do Itaenga',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Juazeiro do Norte',
            subdivision: 'Ceará',
        },
        {
            name: 'José de Freitas',
            subdivision: 'Piauí',
        },
        {
            name: 'João Pessoa',
            subdivision: 'Paraíba',
        },
        {
            name: 'João Câmara',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Jaguaruana',
            subdivision: 'Ceará',
        },
        {
            name: 'Jaguaribe',
            subdivision: 'Ceará',
        },
        {
            name: 'Jaboatão',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Itupiranga',
            subdivision: 'Pará',
        },
        {
            name: 'Itacoatiara',
            subdivision: 'Amazonas',
        },
        {
            name: 'Itaporanga',
            subdivision: 'Paraíba',
        },
        {
            name: 'Itapissuma',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Itapipoca',
            subdivision: 'Ceará',
        },
        {
            name: 'Itapecuru Mirim',
            subdivision: 'Maranhão',
        },
        {
            name: 'Itapagé',
            subdivision: 'Ceará',
        },
        {
            name: 'Itaituba',
            subdivision: 'Pará',
        },
        {
            name: 'Itaitinga',
            subdivision: 'Ceará',
        },
        {
            name: 'Itabaiana',
            subdivision: 'Paraíba',
        },
        {
            name: 'Ipueiras',
            subdivision: 'Ceará',
        },
        {
            name: 'Ipubi',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Ipu',
            subdivision: 'Ceará',
        },
        {
            name: 'Ipojuca',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Imperatriz',
            subdivision: 'Maranhão',
        },
        {
            name: 'Iguatu',
            subdivision: 'Ceará',
        },
        {
            name: 'Igarapé Miri',
            subdivision: 'Pará',
        },
        {
            name: 'Igarapé Açu',
            subdivision: 'Pará',
        },
        {
            name: 'Igarassu',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Icó',
            subdivision: 'Ceará',
        },
        {
            name: 'Horizonte',
            subdivision: 'Ceará',
        },
        {
            name: 'Guaraciaba do Norte',
            subdivision: 'Ceará',
        },
        {
            name: 'Guarabira',
            subdivision: 'Paraíba',
        },
        {
            name: 'Guaiúba',
            subdivision: 'Ceará',
        },
        {
            name: 'Gravatá',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Granja',
            subdivision: 'Ceará',
        },
        {
            name: 'Grajaú',
            subdivision: 'Maranhão',
        },
        {
            name: 'Goiana',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Glória do Goitá',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Garanhuns',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Gameleira',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Fortaleza',
            subdivision: 'Ceará',
        },
        {
            name: 'Floriano',
            subdivision: 'Piauí',
        },
        {
            name: 'Floresta',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Eusébio',
            subdivision: 'Ceará',
        },
        {
            name: 'Extremoz',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Estreito',
            subdivision: 'Maranhão',
        },
        {
            name: 'Esperantina',
            subdivision: 'Piauí',
        },
        {
            name: 'Esperança',
            subdivision: 'Paraíba',
        },
        {
            name: 'Escada',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Dom Pedro',
            subdivision: 'Maranhão',
        },
        {
            name: 'Demerval Lobão',
            subdivision: 'Piauí',
        },
        {
            name: 'Delmiro Gouveia',
            subdivision: 'Alagoas',
        },
        {
            name: 'Custódia',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Cururupu',
            subdivision: 'Maranhão',
        },
        {
            name: 'Currais Novos',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Cupira',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Crato',
            subdivision: 'Ceará',
        },
        {
            name: 'Crateús',
            subdivision: 'Ceará',
        },
        {
            name: 'Coroatá',
            subdivision: 'Maranhão',
        },
        {
            name: 'Condado',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Conceição do Araguaia',
            subdivision: 'Pará',
        },
        {
            name: 'Colinas',
            subdivision: 'Maranhão',
        },
        {
            name: 'Coelho Neto',
            subdivision: 'Maranhão',
        },
        {
            name: 'Codó',
            subdivision: 'Maranhão',
        },
        {
            name: 'Chapadinha',
            subdivision: 'Maranhão',
        },
        {
            name: 'Chã Grande',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Ceará Mirim',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Caxias',
            subdivision: 'Maranhão',
        },
        {
            name: 'Caucaia',
            subdivision: 'Ceará',
        },
        {
            name: 'Catolé do Rocha',
            subdivision: 'Paraíba',
        },
        {
            name: 'Catende',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Castanhal',
            subdivision: 'Pará',
        },
        {
            name: 'Cascavel',
            subdivision: 'Ceará',
        },
        {
            name: 'Caruaru',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Carpina',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Carolina',
            subdivision: 'Maranhão',
        },
        {
            name: 'Capitão Poço',
            subdivision: 'Pará',
        },
        {
            name: 'Capanema',
            subdivision: 'Pará',
        },
        {
            name: 'Canindé',
            subdivision: 'Ceará',
        },
        {
            name: 'Canguaretama',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Campos Sales',
            subdivision: 'Ceará',
        },
        {
            name: 'Campo Maior',
            subdivision: 'Piauí',
        },
        {
            name: 'Campo Alegre',
            subdivision: 'Alagoas',
        },
        {
            name: 'Campina Grande',
            subdivision: 'Paraíba',
        },
        {
            name: 'Camocim',
            subdivision: 'Ceará',
        },
        {
            name: 'Cametá',
            subdivision: 'Pará',
        },
        {
            name: 'Cajueiro',
            subdivision: 'Alagoas',
        },
        {
            name: 'Cajazeiras',
            subdivision: 'Paraíba',
        },
        {
            name: 'Caicó',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Cabrobó',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Cabo',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Cabedelo',
            subdivision: 'Paraíba',
        },
        {
            name: 'Buriti Bravo',
            subdivision: 'Maranhão',
        },
        {
            name: 'Buíque',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Breves',
            subdivision: 'Pará',
        },
        {
            name: 'Brejo Santo',
            subdivision: 'Ceará',
        },
        {
            name: 'Brejo da Madre de Deus',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Bragança',
            subdivision: 'Pará',
        },
        {
            name: 'Bom Conselho',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Boa Viagem',
            subdivision: 'Ceará',
        },
        {
            name: 'Bezerros',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Benevides',
            subdivision: 'Pará',
        },
        {
            name: 'Belo Jardim',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Belém',
            subdivision: 'Paraíba',
        },
        {
            name: 'Belém',
            subdivision: 'Pará',
        },
        {
            name: 'Beberibe',
            subdivision: 'Ceará',
        },
        {
            name: 'Bayeux',
            subdivision: 'Paraíba',
        },
        {
            name: 'Baturité',
            subdivision: 'Ceará',
        },
        {
            name: 'Barreiros',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Barreirinhas',
            subdivision: 'Maranhão',
        },
        {
            name: 'Barras',
            subdivision: 'Piauí',
        },
        {
            name: 'Barra do Corda',
            subdivision: 'Maranhão',
        },
        {
            name: 'Barcarena',
            subdivision: 'Pará',
        },
        {
            name: 'Barbalha',
            subdivision: 'Ceará',
        },
        {
            name: 'Balsas',
            subdivision: 'Maranhão',
        },
        {
            name: 'Bacabal',
            subdivision: 'Maranhão',
        },
        {
            name: 'Augusto Corrêa',
            subdivision: 'Pará',
        },
        {
            name: 'Atalaia',
            subdivision: 'Alagoas',
        },
        {
            name: 'Areia Branca',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Arcoverde',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Araripina',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Arari',
            subdivision: 'Maranhão',
        },
        {
            name: 'Arapiraca',
            subdivision: 'Alagoas',
        },
        {
            name: 'Araguaína',
            subdivision: 'Tocantins',
        },
        {
            name: 'Aracati',
            subdivision: 'Ceará',
        },
        {
            name: 'Aquiraz',
            subdivision: 'Ceará',
        },
        {
            name: 'Apodi',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Ananindeua',
            subdivision: 'Pará',
        },
        {
            name: 'Amaraji',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Altos',
            subdivision: 'Piauí',
        },
        {
            name: 'Altamira',
            subdivision: 'Pará',
        },
        {
            name: 'Almeirim',
            subdivision: 'Pará',
        },
        {
            name: 'Alenquer',
            subdivision: 'Pará',
        },
        {
            name: 'Alagoa Grande',
            subdivision: 'Paraíba',
        },
        {
            name: 'Águas Belas',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Água Preta',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Afogados da Ingazeira',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Açu',
            subdivision: 'Rio Grande do Norte',
        },
        {
            name: 'Acopiara',
            subdivision: 'Ceará',
        },
        {
            name: 'Acaraú',
            subdivision: 'Ceará',
        },
        {
            name: 'Abreu e Lima',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Abaetetuba',
            subdivision: 'Pará',
        },
        {
            name: 'Xique Xique',
            subdivision: 'Bahia',
        },
        {
            name: 'Xanxerê',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Votuporanga',
            subdivision: 'São Paulo',
        },
        {
            name: 'Votorantim',
            subdivision: 'São Paulo',
        },
        {
            name: 'Volta Redonda',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Vitória da Conquista',
            subdivision: 'Bahia',
        },
        {
            name: 'Vitória',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Visconde do Rio Branco',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Viradouro',
            subdivision: 'São Paulo',
        },
        {
            name: 'Vinhedo',
            subdivision: 'São Paulo',
        },
        {
            name: 'Vila Velha',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Videira',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Viçosa',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Viana',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Viamão',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Vespasiano',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Veranópolis',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Vera Cruz',
            subdivision: 'Bahia',
        },
        {
            name: 'Wenceslau Braz',
            subdivision: 'Paraná',
        },
        {
            name: 'Venâncio Aires',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Vazante',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Vassouras',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Várzea Paulista',
            subdivision: 'São Paulo',
        },
        {
            name: 'Várzea Grande',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Várzea da Palma',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Varginha',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Vargem Grande do Sul',
            subdivision: 'São Paulo',
        },
        {
            name: 'Valparaíso',
            subdivision: 'São Paulo',
        },
        {
            name: 'Valinhos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Valença',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Valença',
            subdivision: 'Bahia',
        },
        {
            name: 'Vacaria',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Uruguaiana',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Uruçuca',
            subdivision: 'Bahia',
        },
        {
            name: 'Uruaçu',
            subdivision: 'Goiás',
        },
        {
            name: 'União da Vitória',
            subdivision: 'Paraná',
        },
        {
            name: 'Unaí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Una',
            subdivision: 'Bahia',
        },
        {
            name: 'Umuarama',
            subdivision: 'Paraná',
        },
        {
            name: 'Uberlândia',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Uberaba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ubatuba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ubatã',
            subdivision: 'Bahia',
        },
        {
            name: 'Ubaitaba',
            subdivision: 'Bahia',
        },
        {
            name: 'Ubá',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Tupanciretã',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Tupaciguara',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Tupã',
            subdivision: 'São Paulo',
        },
        {
            name: 'Tucano',
            subdivision: 'Bahia',
        },
        {
            name: 'Tubarão',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Trindade',
            subdivision: 'Goiás',
        },
        {
            name: 'Três Rios',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Três Pontas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Três Passos',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Três Lagoas',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Três de Maio',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Três Coroas',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Três Corações',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Tremembé',
            subdivision: 'São Paulo',
        },
        {
            name: 'Tramandaí',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Torres',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Toledo',
            subdivision: 'Paraná',
        },
        {
            name: 'Tobias Barreto',
            subdivision: 'Sergipe',
        },
        {
            name: 'Timóteo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Timbó',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Tijucas',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Tietê',
            subdivision: 'São Paulo',
        },
        {
            name: 'Teutônia',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Teresópolis',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Teófilo Otoni',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Teodoro Sampaio',
            subdivision: 'São Paulo',
        },
        {
            name: 'Telêmaco Borba',
            subdivision: 'Paraná',
        },
        {
            name: 'Taubaté',
            subdivision: 'São Paulo',
        },
        {
            name: 'Tatuí',
            subdivision: 'São Paulo',
        },
        {
            name: 'Taquarituba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Taquaritinga',
            subdivision: 'São Paulo',
        },
        {
            name: 'Taquari',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Taquara',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Tapiramutá',
            subdivision: 'Bahia',
        },
        {
            name: 'Tapes',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Tanguá',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Tanabi',
            subdivision: 'São Paulo',
        },
        {
            name: 'Tambaú',
            subdivision: 'São Paulo',
        },
        {
            name: 'Taiobeiras',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Taboão da Serra',
            subdivision: 'São Paulo',
        },
        {
            name: 'Suzano',
            subdivision: 'São Paulo',
        },
        {
            name: 'Sumaré',
            subdivision: 'São Paulo',
        },
        {
            name: 'Sorocaba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Soledade',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Socorro',
            subdivision: 'São Paulo',
        },
        {
            name: 'Sobradinho',
            subdivision: 'Bahia',
        },
        {
            name: 'Simão Dias',
            subdivision: 'Sergipe',
        },
        {
            name: 'Silva Jardim',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Sidrolândia',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Sete Lagoas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Sertãozinho',
            subdivision: 'São Paulo',
        },
        {
            name: 'Serrinha',
            subdivision: 'Bahia',
        },
        {
            name: 'Serra Negra',
            subdivision: 'São Paulo',
        },
        {
            name: 'Serrana',
            subdivision: 'São Paulo',
        },
        {
            name: 'Serra',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Seropédica',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Senhor do Bonfim',
            subdivision: 'Bahia',
        },
        {
            name: 'Senador Canedo',
            subdivision: 'Goiás',
        },
        {
            name: 'Seabra',
            subdivision: 'Bahia',
        },
        {
            name: 'Schroeder',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Saubara',
            subdivision: 'Bahia',
        },
        {
            name: 'Sarzedo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Sarandi',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Sarandi',
            subdivision: 'Paraná',
        },
        {
            name: 'Saquarema',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Sapucaia',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Sapiranga',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Vicente',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Sepé',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Sebastião do Passé',
            subdivision: 'Bahia',
        },
        {
            name: 'São Sebastião do Paraíso',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'São Sebastião do Caí',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Sebastião',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Roque',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Pedro da Aldeia',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'São Pedro',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Paulo',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Miguel do Iguaçu',
            subdivision: 'Paraná',
        },
        {
            name: 'São Miguel do Araguaia',
            subdivision: 'Goiás',
        },
        {
            name: 'São Mateus do Sul',
            subdivision: 'Paraná',
        },
        {
            name: 'São Mateus',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'São Marcos',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Manuel',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Luiz Gonzaga',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Luís de Montes Belos',
            subdivision: 'Goiás',
        },
        {
            name: 'São Lourenço do Sul',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Lourenço',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'São Leopoldo',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São José dos Pinhais',
            subdivision: 'Paraná',
        },
        {
            name: 'São José dos Campos',
            subdivision: 'São Paulo',
        },
        {
            name: 'São José do Rio Preto',
            subdivision: 'São Paulo',
        },
        {
            name: 'São José do Rio Pardo',
            subdivision: 'São Paulo',
        },
        {
            name: 'São José',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'São Joaquim da Barra',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Joaquim',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'São João Nepomuceno',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'São João de Meriti',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'São João del Rei',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'São João da Boa Vista',
            subdivision: 'São Paulo',
        },
        {
            name: 'São João da Barra',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'São Jerônimo',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Gotardo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'São Gonçalo do Sapucaí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'São Gabriel',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Francisco do Sul',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'São Francisco do Conde',
            subdivision: 'Bahia',
        },
        {
            name: 'São Francisco',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'São Fidélis',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'São Cristóvão',
            subdivision: 'Sergipe',
        },
        {
            name: 'São Carlos',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Caetano do Sul',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Borja',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'São Bernardo do Campo',
            subdivision: 'São Paulo',
        },
        {
            name: 'São Bento do Sul',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Santos Dumont',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Santos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santo Estêvão',
            subdivision: 'Bahia',
        },
        {
            name: 'Santo Antônio do Monte',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Santo Antônio do Amparo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Santo Antônio de Posse',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santo Antônio de Pádua',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Santo Antônio de Jesus',
            subdivision: 'Bahia',
        },
        {
            name: 'Santo Antônio da Platina',
            subdivision: 'Paraná',
        },
        {
            name: 'Santo Ângelo',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Santo André',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santo Anastácio',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santo Amaro da Imperatriz',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Santo Amaro',
            subdivision: 'Bahia',
        },
        {
            name: 'Santiago',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Santa Vitória do Palmar',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Santa Rosa de Viterbo',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santa Rosa',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Santa Rita do Sapucaí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Santa Rita do Passa Quatro',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santana do Paraíso',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Santana do Livramento',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Santana de Parnaíba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santa Maria da Vitória',
            subdivision: 'Bahia',
        },
        {
            name: 'Santa Maria',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Santa Luzia',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Santaluz',
            subdivision: 'Bahia',
        },
        {
            name: 'Santa Isabel',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santa Helena de Goiás',
            subdivision: 'Goiás',
        },
        {
            name: 'Santa Gertrudes',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santa Fé do Sul',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santa Cruz do Sul',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Santa Cruz do Rio Pardo',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santa Cruz das Palmeiras',
            subdivision: 'São Paulo',
        },
        {
            name: 'Santa Cruz Cabrália',
            subdivision: 'Bahia',
        },
        {
            name: 'Santa Cecília',
            subdivision: 'Santa Catarina',
        },
        {
            name: "Santa Bárbara d'Oeste",
            subdivision: 'São Paulo',
        },
        {
            name: 'Salvador',
            subdivision: 'Bahia',
        },
        {
            name: 'Salto de Pirapora',
            subdivision: 'São Paulo',
        },
        {
            name: 'Salto',
            subdivision: 'São Paulo',
        },
        {
            name: 'Salinas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Sacramento',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ruy Barbosa',
            subdivision: 'Bahia',
        },
        {
            name: 'Rubiataba',
            subdivision: 'Goiás',
        },
        {
            name: 'Rosário do Sul',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Rondonópolis',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Rolante',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Rolândia',
            subdivision: 'Paraná',
        },
        {
            name: 'Rio Verde de Mato Grosso',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Rio Real',
            subdivision: 'Bahia',
        },
        {
            name: 'Rio Pardo',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Rio Negro',
            subdivision: 'Paraná',
        },
        {
            name: 'Rio Negrinho',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Rio Grande da Serra',
            subdivision: 'São Paulo',
        },
        {
            name: 'Rio Grande',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Rio do Sul',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Rio de Janeiro',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Rio das Pedras',
            subdivision: 'São Paulo',
        },
        {
            name: 'Rio das Ostras',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Rio Claro',
            subdivision: 'São Paulo',
        },
        {
            name: 'Rio Brilhante',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Rio Branco do Sul',
            subdivision: 'Paraná',
        },
        {
            name: 'Rio Bonito',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Ribeirão Preto',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ribeirão Pires',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ribeirão das Neves',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ribeirão da Ilha',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Ribeira do Pombal',
            subdivision: 'Bahia',
        },
        {
            name: 'Riachão do Jacuípe',
            subdivision: 'Bahia',
        },
        {
            name: 'Resplendor',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Resende',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Registro',
            subdivision: 'São Paulo',
        },
        {
            name: 'Regente Feijó',
            subdivision: 'São Paulo',
        },
        {
            name: 'Rancharia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Quirinópolis',
            subdivision: 'Goiás',
        },
        {
            name: 'Queimados',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Quatro Barras',
            subdivision: 'Paraná',
        },
        {
            name: 'Quaraí',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Prudentópolis',
            subdivision: 'Paraná',
        },
        {
            name: 'Propriá',
            subdivision: 'Sergipe',
        },
        {
            name: 'Promissão',
            subdivision: 'São Paulo',
        },
        {
            name: 'Presidente Venceslau',
            subdivision: 'São Paulo',
        },
        {
            name: 'Presidente Prudente',
            subdivision: 'São Paulo',
        },
        {
            name: 'Presidente Epitácio',
            subdivision: 'São Paulo',
        },
        {
            name: 'Prata',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Praia Grande',
            subdivision: 'São Paulo',
        },
        {
            name: 'Prado',
            subdivision: 'Bahia',
        },
        {
            name: 'Pouso Alegre',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Posse',
            subdivision: 'Goiás',
        },
        {
            name: 'Porto União',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Porto Seguro',
            subdivision: 'Bahia',
        },
        {
            name: 'Porto Ferreira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Porto Feliz',
            subdivision: 'São Paulo',
        },
        {
            name: 'Porto Alegre',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Portão',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Porangatu',
            subdivision: 'Goiás',
        },
        {
            name: 'Pontes e Lacerda',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Ponte Nova',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ponta Porã',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Pontal',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ponta Grossa',
            subdivision: 'Paraná',
        },
        {
            name: 'Pompéu',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pompéia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pomerode',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Poços de Caldas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Poconé',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Poções',
            subdivision: 'Bahia',
        },
        {
            name: 'Poá',
            subdivision: 'São Paulo',
        },
        {
            name: 'Planaltina',
            subdivision: 'Goiás',
        },
        {
            name: 'Piúma',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Piuí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pitangui',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pitangueiras',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pitanga',
            subdivision: 'Paraná',
        },
        {
            name: 'Piritiba',
            subdivision: 'Bahia',
        },
        {
            name: 'Pires do Rio',
            subdivision: 'Goiás',
        },
        {
            name: 'Piraquara',
            subdivision: 'Paraná',
        },
        {
            name: 'Pirapozinho',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pirapora',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pirajuí',
            subdivision: 'São Paulo',
        },
        {
            name: 'Piraju',
            subdivision: 'São Paulo',
        },
        {
            name: 'Piraí do Sul',
            subdivision: 'Paraná',
        },
        {
            name: 'Piraí',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Pirassununga',
            subdivision: 'São Paulo',
        },
        {
            name: 'Piracicaba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Piracanjuba',
            subdivision: 'Goiás',
        },
        {
            name: 'Piracaia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pinheiral',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Pinhão',
            subdivision: 'Paraná',
        },
        {
            name: 'Espírito Santo do Pinhal',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pindobaçu',
            subdivision: 'Bahia',
        },
        {
            name: 'Pindamonhangaba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pilar do Sul',
            subdivision: 'São Paulo',
        },
        {
            name: 'Piedade',
            subdivision: 'São Paulo',
        },
        {
            name: 'Petrópolis',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Peruíbe',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pereira Barreto',
            subdivision: 'São Paulo',
        },
        {
            name: 'Perdões',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Penha',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Penedo',
            subdivision: 'Alagoas',
        },
        {
            name: 'Penápolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pelotas',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Pedro Leopoldo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pedreira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Pedra Azul',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pederneiras',
            subdivision: 'São Paulo',
        },
        {
            name: 'Paulínia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Patrocínio',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Patos de Minas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pato Branco',
            subdivision: 'Paraná',
        },
        {
            name: 'Paty do Alferes',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Passos',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Passo Fundo',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Parobé',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Paraty',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Paranavaí',
            subdivision: 'Paraná',
        },
        {
            name: 'Paranapanema',
            subdivision: 'São Paulo',
        },
        {
            name: 'Paranaíba',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Paranaguá',
            subdivision: 'Paraná',
        },
        {
            name: 'Paraíba do Sul',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Paraguaçu Paulista',
            subdivision: 'São Paulo',
        },
        {
            name: 'Paraguaçu',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Pará de Minas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Paracatu',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Paracambi',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Panambi',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Palotina',
            subdivision: 'Paraná',
        },
        {
            name: 'Palmital',
            subdivision: 'São Paulo',
        },
        {
            name: 'Palmeira das Missões',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Palmeira',
            subdivision: 'Paraná',
        },
        {
            name: 'Palmas',
            subdivision: 'Paraná',
        },
        {
            name: 'Palhoça',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Paiçandu',
            subdivision: 'Paraná',
        },
        {
            name: 'Padre Bernardo',
            subdivision: 'Goiás',
        },
        {
            name: 'Ouro Preto',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ouro Branco',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ourinhos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Osvaldo Cruz',
            subdivision: 'São Paulo',
        },
        {
            name: 'Osório',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Osasco',
            subdivision: 'São Paulo',
        },
        {
            name: 'Orleans',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Orlândia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Oliveira',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Olímpia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Novo Horizonte',
            subdivision: 'São Paulo',
        },
        {
            name: 'Novo Hamburgo',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Nova Viçosa',
            subdivision: 'Bahia',
        },
        {
            name: 'Nova Venécia',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Nova Prata',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Nova Petrópolis',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Nova Olímpia',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Nova Odessa',
            subdivision: 'São Paulo',
        },
        {
            name: 'Nova Lima',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Nova Iguaçu',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Nova Granada',
            subdivision: 'São Paulo',
        },
        {
            name: 'Nova Friburgo',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Nova Era',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Nossa Senhora do Socorro',
            subdivision: 'Sergipe',
        },
        {
            name: 'Nossa Senhora da Glória',
            subdivision: 'Sergipe',
        },
        {
            name: 'Niterói',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Niquelândia',
            subdivision: 'Goiás',
        },
        {
            name: 'Nilópolis',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Nerópolis',
            subdivision: 'Goiás',
        },
        {
            name: 'Nepomuceno',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Nazaré',
            subdivision: 'Bahia',
        },
        {
            name: 'Naviraí',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Navegantes',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Nanuque',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Muzambinho',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Muritiba',
            subdivision: 'Bahia',
        },
        {
            name: 'Muriaé',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Mucuri',
            subdivision: 'Bahia',
        },
        {
            name: 'Morro do Chapéu',
            subdivision: 'Bahia',
        },
        {
            name: 'Morro Agudo',
            subdivision: 'São Paulo',
        },
        {
            name: 'Morrinhos',
            subdivision: 'Goiás',
        },
        {
            name: 'Montes Claros',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Monte Santo de Minas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Montenegro',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Monte Mor',
            subdivision: 'São Paulo',
        },
        {
            name: 'Monte Carmelo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Monte Azul Paulista',
            subdivision: 'São Paulo',
        },
        {
            name: 'Monte Aprazível',
            subdivision: 'São Paulo',
        },
        {
            name: 'Monte Alto',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mongaguá',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mogi Mirim',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mogi-Gaucu',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mogi das Cruzes',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mococa',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mirandopólis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Miracema',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Mineiros',
            subdivision: 'Goiás',
        },
        {
            name: 'Miguel Pereira',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Miguelópolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mendes',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Medianeira',
            subdivision: 'Paraná',
        },
        {
            name: 'Medeiros Neto',
            subdivision: 'Bahia',
        },
        {
            name: 'Mauá',
            subdivision: 'São Paulo',
        },
        {
            name: 'Matozinhos',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Mateus Leme',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Matão',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mata de São João',
            subdivision: 'Bahia',
        },
        {
            name: 'Mascote',
            subdivision: 'Bahia',
        },
        {
            name: 'Martinópolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Maringá',
            subdivision: 'Paraná',
        },
        {
            name: 'Marília',
            subdivision: 'São Paulo',
        },
        {
            name: 'Maricá',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Mariana',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Marialva',
            subdivision: 'Paraná',
        },
        {
            name: 'Marechal Cândido Rondon',
            subdivision: 'Paraná',
        },
        {
            name: 'Marau',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Marataizes',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Maragogipe',
            subdivision: 'Bahia',
        },
        {
            name: 'Maracás',
            subdivision: 'Bahia',
        },
        {
            name: 'Maracaju',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Manhumirim',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Manhuaçu',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Mangaratiba',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Mandaguari',
            subdivision: 'Paraná',
        },
        {
            name: 'Mairiporã',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mairinque',
            subdivision: 'São Paulo',
        },
        {
            name: 'Mafra',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Machado',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Macatuba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Macaé',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Luziânia',
            subdivision: 'Goiás',
        },
        {
            name: 'Lucas',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Louveira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Lorena',
            subdivision: 'São Paulo',
        },
        {
            name: 'Londrina',
            subdivision: 'Paraná',
        },
        {
            name: 'Loanda',
            subdivision: 'Paraná',
        },
        {
            name: 'Livramento do Brumado',
            subdivision: 'Bahia',
        },
        {
            name: 'Lins',
            subdivision: 'São Paulo',
        },
        {
            name: 'Linhares',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Limeira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Leopoldina',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Lençóis Paulista',
            subdivision: 'São Paulo',
        },
        {
            name: 'Leme',
            subdivision: 'São Paulo',
        },
        {
            name: 'Lavras',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Laranjeiras do Sul',
            subdivision: 'Paraná',
        },
        {
            name: 'Laranjeiras',
            subdivision: 'Sergipe',
        },
        {
            name: 'Laranjal Paulista',
            subdivision: 'São Paulo',
        },
        {
            name: 'Lapa',
            subdivision: 'Paraná',
        },
        {
            name: 'Lajinha',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Lages',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Lajeado',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Laguna',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Lagoa Vermelha',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Lagoa Santa',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Lagoa da Prata',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Lagarto',
            subdivision: 'Sergipe',
        },
        {
            name: 'Ladário',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Jundiaí',
            subdivision: 'São Paulo',
        },
        {
            name: 'Júlio de Castilhos',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Juiz de Fora',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Juatuba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'José Bonifácio',
            subdivision: 'São Paulo',
        },
        {
            name: 'Joinville',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'João Pinheiro',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'João Monlevade',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Joaçaba',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Jeremoabo',
            subdivision: 'Bahia',
        },
        {
            name: 'Jequitinhonha',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Jequié',
            subdivision: 'Bahia',
        },
        {
            name: 'Jaú',
            subdivision: 'São Paulo',
        },
        {
            name: 'Jataí',
            subdivision: 'Goiás',
        },
        {
            name: 'Jarinu',
            subdivision: 'São Paulo',
        },
        {
            name: 'Jardinópolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Jardim',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Jaraguá do Sul',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Jaraguá',
            subdivision: 'Goiás',
        },
        {
            name: 'Japeri',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Januária',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Jandira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Jandaia do Sul',
            subdivision: 'Paraná',
        },
        {
            name: 'Janaúba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Jales',
            subdivision: 'São Paulo',
        },
        {
            name: 'Jaguariúna',
            subdivision: 'São Paulo',
        },
        {
            name: 'Jaguariaíva',
            subdivision: 'Paraná',
        },
        {
            name: 'Jaguarari',
            subdivision: 'Bahia',
        },
        {
            name: 'Jaguarão',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Jaguaquara',
            subdivision: 'Bahia',
        },
        {
            name: 'Jacutinga',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Jacobina',
            subdivision: 'Bahia',
        },
        {
            name: 'Jaciara',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Jacarezinho',
            subdivision: 'Paraná',
        },
        {
            name: 'Jacareí',
            subdivision: 'São Paulo',
        },
        {
            name: 'Jaboticabal',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ivoti',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Ituverava',
            subdivision: 'São Paulo',
        },
        {
            name: 'Iturama',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Itupeva',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itumbiara',
            subdivision: 'Goiás',
        },
        {
            name: 'Ituiutaba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ituberá',
            subdivision: 'Bahia',
        },
        {
            name: 'Itu',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itororó',
            subdivision: 'Bahia',
        },
        {
            name: 'Itaúna',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Itatinga',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itatiba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itararé',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itaqui',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Itaquaquecetuba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itapuranga',
            subdivision: 'Goiás',
        },
        {
            name: 'Itápolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itapira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itapevi',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itapeva',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itapetininga',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itapetinga',
            subdivision: 'Bahia',
        },
        {
            name: 'Itaperuna',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Itaperuçu',
            subdivision: 'Paraná',
        },
        {
            name: 'Itapemirim',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Itapema',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Itapecerica da Serra',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itapecerica',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Itaparica',
            subdivision: 'Bahia',
        },
        {
            name: 'Itapaci',
            subdivision: 'Goiás',
        },
        {
            name: 'Itaocara',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Itanhaém',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itambé',
            subdivision: 'Bahia',
        },
        {
            name: 'Itamarandiba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Itamaraju',
            subdivision: 'Bahia',
        },
        {
            name: 'Itajuípe',
            subdivision: 'Bahia',
        },
        {
            name: 'Itajubá',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Itajaí',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Itaí',
            subdivision: 'São Paulo',
        },
        {
            name: 'Itaguaí',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Itabuna',
            subdivision: 'Bahia',
        },
        {
            name: 'Itaboraí',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Itabirito',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Itabira',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Itaberaí',
            subdivision: 'Goiás',
        },
        {
            name: 'Itaberaba',
            subdivision: 'Bahia',
        },
        {
            name: 'Itabaianinha',
            subdivision: 'Sergipe',
        },
        {
            name: 'Itabaiana',
            subdivision: 'Sergipe',
        },
        {
            name: 'Irecê',
            subdivision: 'Bahia',
        },
        {
            name: 'Irati',
            subdivision: 'Paraná',
        },
        {
            name: 'Iracemápolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Iporá',
            subdivision: 'Goiás',
        },
        {
            name: 'Ipirá',
            subdivision: 'Bahia',
        },
        {
            name: 'Ipiaú',
            subdivision: 'Bahia',
        },
        {
            name: 'Iperó',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ipatinga',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ipameri',
            subdivision: 'Goiás',
        },
        {
            name: 'Ipaba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Inhumas',
            subdivision: 'Goiás',
        },
        {
            name: 'Indaiatuba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Indaial',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Imbituva',
            subdivision: 'Paraná',
        },
        {
            name: 'Imbituba',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Ilhéus',
            subdivision: 'Bahia',
        },
        {
            name: 'Ilha Solteira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ilhabela',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ijuí',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Iguape',
            subdivision: 'São Paulo',
        },
        {
            name: 'Igrejinha',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Igarapé',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Igarapava',
            subdivision: 'São Paulo',
        },
        {
            name: 'Igaraçu do Tietê',
            subdivision: 'São Paulo',
        },
        {
            name: 'Içara',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Ibotirama',
            subdivision: 'Bahia',
        },
        {
            name: 'Ibiúna',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ibitinga',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ibirité',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ibirataia',
            subdivision: 'Bahia',
        },
        {
            name: 'Ibirama',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Ibiporã',
            subdivision: 'Paraná',
        },
        {
            name: 'Ibicaraí',
            subdivision: 'Bahia',
        },
        {
            name: 'Ibiá',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Ibaté',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ibaiti',
            subdivision: 'Paraná',
        },
        {
            name: 'Iaçu',
            subdivision: 'Bahia',
        },
        {
            name: 'Hortolândia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Herval',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Gurupi',
            subdivision: 'Tocantins',
        },
        {
            name: 'Guaxupé',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Guarulhos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guarujá',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guariba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guaratuba',
            subdivision: 'Paraná',
        },
        {
            name: 'Guaratinguetá',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guararema',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guararapes',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guarapuava',
            subdivision: 'Paraná',
        },
        {
            name: 'Guarapari',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Guaranésia',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Guaramirim',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Guará',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guaporé',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Guapimirim',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Guanhães',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Guanambi',
            subdivision: 'Bahia',
        },
        {
            name: 'Guaíra',
            subdivision: 'São Paulo',
        },
        {
            name: 'Guaçuí',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Gravataí',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Governador Valadares',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Goiatuba',
            subdivision: 'Goiás',
        },
        {
            name: 'Goiás',
            subdivision: 'Goiás',
        },
        {
            name: 'Goianira',
            subdivision: 'Goiás',
        },
        {
            name: 'Goiânia',
            subdivision: 'Goiás',
        },
        {
            name: 'Goianésia',
            subdivision: 'Goiás',
        },
        {
            name: 'Gaspar',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Garibaldi',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Garça',
            subdivision: 'São Paulo',
        },
        {
            name: 'Gandu',
            subdivision: 'Bahia',
        },
        {
            name: 'Frutal',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Frederico Westphalen',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Franco da Rocha',
            subdivision: 'São Paulo',
        },
        {
            name: 'Francisco Morato',
            subdivision: 'São Paulo',
        },
        {
            name: 'Francisco Beltrão',
            subdivision: 'Paraná',
        },
        {
            name: 'Franca',
            subdivision: 'São Paulo',
        },
        {
            name: 'Foz do Iguaçu',
            subdivision: 'Paraná',
        },
        {
            name: 'Forquilhinha',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Formosa',
            subdivision: 'Goiás',
        },
        {
            name: 'Formiga',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Florianópolis',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Flores da Cunha',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Ferraz de Vasconcelos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Fernandópolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Feira de Santana',
            subdivision: 'Bahia',
        },
        {
            name: 'Farroupilha',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Euclides da Cunha',
            subdivision: 'Bahia',
        },
        {
            name: 'Estrela',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Esteio',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Estância Velha',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Estância',
            subdivision: 'Sergipe',
        },
        {
            name: 'Esplanada',
            subdivision: 'Bahia',
        },
        {
            name: 'Espinosa',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Esmeraldas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Erechim',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Entre Rios',
            subdivision: 'Bahia',
        },
        {
            name: 'Encruzilhada do Sul',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Encantado',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Embu Guaçu',
            subdivision: 'São Paulo',
        },
        {
            name: 'Embu',
            subdivision: 'São Paulo',
        },
        {
            name: 'Elói Mendes',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Duque de Caxias',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Dourados',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Dom Pedrito',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Dois Vizinhos',
            subdivision: 'Paraná',
        },
        {
            name: 'Dois Córregos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Divinópolis',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Diamantino',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Diamantina',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Diadema',
            subdivision: 'São Paulo',
        },
        {
            name: 'Descalvado',
            subdivision: 'São Paulo',
        },
        {
            name: 'Curvelo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Curitibanos',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Curitiba',
            subdivision: 'Paraná',
        },
        {
            name: 'Cuiabá',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Cubatão',
            subdivision: 'São Paulo',
        },
        {
            name: 'Cruzeiro do Oeste',
            subdivision: 'Paraná',
        },
        {
            name: 'Cruzeiro',
            subdivision: 'São Paulo',
        },
        {
            name: 'Cruz das Almas',
            subdivision: 'Bahia',
        },
        {
            name: 'Cruz Alta',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Cristalina',
            subdivision: 'Goiás',
        },
        {
            name: 'Criciúma',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Cravinhos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Coxim',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Cotia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Cosmópolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Coruripe',
            subdivision: 'Alagoas',
        },
        {
            name: 'Corumbá',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Coronel Vivida',
            subdivision: 'Paraná',
        },
        {
            name: 'Coronel Fabriciano',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Coromandel',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Cornélio Procópio',
            subdivision: 'Paraná',
        },
        {
            name: 'Corinto',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Cordeirópolis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Cordeiro',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Contagem',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Conselheiro Lafaiete',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Congonhas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Conde',
            subdivision: 'Bahia',
        },
        {
            name: 'Concórdia',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Conchal',
            subdivision: 'São Paulo',
        },
        {
            name: 'Conceição do Coité',
            subdivision: 'Bahia',
        },
        {
            name: 'Conceição do Jacuípe',
            subdivision: 'Bahia',
        },
        {
            name: 'Conceição das Alagoas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Conceição da Feira',
            subdivision: 'Bahia',
        },
        {
            name: 'Conceição da Barra',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Colorado',
            subdivision: 'Paraná',
        },
        {
            name: 'Colombo',
            subdivision: 'Paraná',
        },
        {
            name: 'Colatina',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Coaraci',
            subdivision: 'Bahia',
        },
        {
            name: 'Cláudio',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Cícero Dantas',
            subdivision: 'Bahia',
        },
        {
            name: 'Cianorte',
            subdivision: 'Paraná',
        },
        {
            name: 'Charqueadas',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Chapecó',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Cerquilho',
            subdivision: 'São Paulo',
        },
        {
            name: 'Ceres',
            subdivision: 'Goiás',
        },
        {
            name: 'Celso Ramos',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Caxias do Sul',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Caxambu',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Catu',
            subdivision: 'Bahia',
        },
        {
            name: 'Catanduva',
            subdivision: 'São Paulo',
        },
        {
            name: 'Catalão',
            subdivision: 'Goiás',
        },
        {
            name: 'Cataguases',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Castro',
            subdivision: 'Paraná',
        },
        {
            name: 'Castelo',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Cassilândia',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Casimiro de Abreu',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Cascavel',
            subdivision: 'Paraná',
        },
        {
            name: 'Casa Branca',
            subdivision: 'São Paulo',
        },
        {
            name: 'Carmo do Paranaíba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Carmo do Cajuru',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Carlos Barbosa',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Carazinho',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Caratinga',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Carapicuíba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Carangola',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Carandaí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Caraguatatuba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Capivari',
            subdivision: 'São Paulo',
        },
        {
            name: 'Capinzal',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Capim Grosso',
            subdivision: 'Bahia',
        },
        {
            name: 'Capelinha',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Capela',
            subdivision: 'Sergipe',
        },
        {
            name: 'Capão da Canoa',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Capâo Bonito',
            subdivision: 'São Paulo',
        },
        {
            name: 'Canoinhas',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Canoas',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Canguçu',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Canela',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Cândido Mota',
            subdivision: 'São Paulo',
        },
        {
            name: 'Candelária',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Canavieiras',
            subdivision: 'Bahia',
        },
        {
            name: 'Campo Verde',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Campos Novos',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Campos Gerais',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Campos do Jordão',
            subdivision: 'São Paulo',
        },
        {
            name: 'Campos Belos',
            subdivision: 'Goiás',
        },
        {
            name: 'Campos',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Campo Mourão',
            subdivision: 'Paraná',
        },
        {
            name: 'Campo Largo',
            subdivision: 'Paraná',
        },
        {
            name: 'Campo Grande',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Campo Formoso',
            subdivision: 'Bahia',
        },
        {
            name: 'Campo Belo',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Campinas',
            subdivision: 'São Paulo',
        },
        {
            name: 'Campina Grande do Sul',
            subdivision: 'Paraná',
        },
        {
            name: 'Cambuí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Cambé',
            subdivision: 'Paraná',
        },
        {
            name: 'Cambará',
            subdivision: 'Paraná',
        },
        {
            name: 'Camaquã',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Camanducaia',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Camaçari',
            subdivision: 'Bahia',
        },
        {
            name: 'Caldas Novas',
            subdivision: 'Goiás',
        },
        {
            name: 'Cajuru',
            subdivision: 'São Paulo',
        },
        {
            name: 'Cajati',
            subdivision: 'São Paulo',
        },
        {
            name: 'Cajamar',
            subdivision: 'São Paulo',
        },
        {
            name: 'Caieiras',
            subdivision: 'São Paulo',
        },
        {
            name: 'Caetité',
            subdivision: 'Bahia',
        },
        {
            name: 'Caeté',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Cachoeiro de Itapemirim',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Cachoeirinha',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Cachoeiras de Macacu',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Cachoeira do Sul',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Cachoeira',
            subdivision: 'Bahia',
        },
        {
            name: 'Caçapava do Sul',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Caçapava',
            subdivision: 'São Paulo',
        },
        {
            name: 'Caçador',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Cabreúva',
            subdivision: 'São Paulo',
        },
        {
            name: 'Cabo Frio',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Butiá',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Buritizeiro',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Buritis',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Buri',
            subdivision: 'São Paulo',
        },
        {
            name: 'Buerarema',
            subdivision: 'Bahia',
        },
        {
            name: 'Brusque',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Brumado',
            subdivision: 'Bahia',
        },
        {
            name: 'Brumadinho',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Brotas',
            subdivision: 'São Paulo',
        },
        {
            name: 'Brodósqui',
            subdivision: 'São Paulo',
        },
        {
            name: 'Brasília',
            subdivision: 'Federal District',
        },
        {
            name: 'Bragança Paulista',
            subdivision: 'São Paulo',
        },
        {
            name: 'Braço do Norte',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Botucatu',
            subdivision: 'São Paulo',
        },
        {
            name: 'Bom Jesus do Itabapoana',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Bom Jesus da Lapa',
            subdivision: 'Bahia',
        },
        {
            name: 'Bom Despacho',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Boituva',
            subdivision: 'São Paulo',
        },
        {
            name: 'Bocaiúva',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Boa Esperança',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Blumenau',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Biritiba Mirim',
            subdivision: 'São Paulo',
        },
        {
            name: 'Birigui',
            subdivision: 'São Paulo',
        },
        {
            name: 'Biguaçu',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Betim',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Bertioga',
            subdivision: 'São Paulo',
        },
        {
            name: 'Bento Gonçalves',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Belo Oriente',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Belo Horizonte',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Belford Roxo',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Bela Vista',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Bebedouro',
            subdivision: 'São Paulo',
        },
        {
            name: 'Bauru',
            subdivision: 'São Paulo',
        },
        {
            name: 'Batatais',
            subdivision: 'São Paulo',
        },
        {
            name: 'Bastos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Barueri',
            subdivision: 'São Paulo',
        },
        {
            name: 'Barroso',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Barrinha',
            subdivision: 'São Paulo',
        },
        {
            name: 'Barretos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Barreiro do Jaíba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Barreiras',
            subdivision: 'Bahia',
        },
        {
            name: 'Barra Velha',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Barra Mansa',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Barra dos Coqueiros',
            subdivision: 'Sergipe',
        },
        {
            name: 'Barra do Piraí',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Barra do Garças',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Barra do Bugres',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Barra de São Francisco',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Barra Bonita',
            subdivision: 'São Paulo',
        },
        {
            name: 'Barra',
            subdivision: 'Bahia',
        },
        {
            name: 'Bariri',
            subdivision: 'São Paulo',
        },
        {
            name: 'Barbacena',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Barão de Cocais',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Bandeirantes',
            subdivision: 'Paraná',
        },
        {
            name: 'Bambuí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Balneário Camboriú',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Baixo Guandu',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Bagé',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Avaré',
            subdivision: 'São Paulo',
        },
        {
            name: 'Atibaia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Astorga',
            subdivision: 'Paraná',
        },
        {
            name: 'Assis',
            subdivision: 'São Paulo',
        },
        {
            name: 'Arujá',
            subdivision: 'São Paulo',
        },
        {
            name: 'Artur Nogueira',
            subdivision: 'São Paulo',
        },
        {
            name: 'Arroio Grande',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Arroio do Meio',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Arraial do Cabo',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Armação de Búzios',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Arcos',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Araxá',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Araucária',
            subdivision: 'Paraná',
        },
        {
            name: 'Araruama',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Araras',
            subdivision: 'São Paulo',
        },
        {
            name: 'Araraquara',
            subdivision: 'São Paulo',
        },
        {
            name: 'Araranguá',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Arapongas',
            subdivision: 'Paraná',
        },
        {
            name: 'Araguari',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Aragarças',
            subdivision: 'Goiás',
        },
        {
            name: 'Araçuaí',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Aracruz',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Araçoiaba da Serra',
            subdivision: 'São Paulo',
        },
        {
            name: 'Araci',
            subdivision: 'Bahia',
        },
        {
            name: 'Araçatuba',
            subdivision: 'São Paulo',
        },
        {
            name: 'Aracaju',
            subdivision: 'Sergipe',
        },
        {
            name: 'Aquidauana',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Apucarana',
            subdivision: 'Paraná',
        },
        {
            name: 'Apiaí',
            subdivision: 'São Paulo',
        },
        {
            name: 'Aparecida do Taboado',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Aparecida',
            subdivision: 'São Paulo',
        },
        {
            name: 'Antonina',
            subdivision: 'Paraná',
        },
        {
            name: 'Anicuns',
            subdivision: 'Goiás',
        },
        {
            name: 'Angra dos Reis',
            subdivision: 'Rio de Janeiro',
        },
        {
            name: 'Andradina',
            subdivision: 'São Paulo',
        },
        {
            name: 'Andradas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Anastácio',
            subdivision: 'Mato Grosso do Sul',
        },
        {
            name: 'Anápolis',
            subdivision: 'Goiás',
        },
        {
            name: 'Amparo',
            subdivision: 'São Paulo',
        },
        {
            name: 'Américo Brasiliense',
            subdivision: 'São Paulo',
        },
        {
            name: 'Americana',
            subdivision: 'São Paulo',
        },
        {
            name: 'Amargosa',
            subdivision: 'Bahia',
        },
        {
            name: 'Álvares Machado',
            subdivision: 'São Paulo',
        },
        {
            name: 'Almirante Tamandaré',
            subdivision: 'Paraná',
        },
        {
            name: 'Almenara',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Alfenas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Além Paraíba',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Alegrete',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Alegre',
            subdivision: 'Espírito Santo',
        },
        {
            name: 'Alagoinhas',
            subdivision: 'Bahia',
        },
        {
            name: 'Aimorés',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Agudos',
            subdivision: 'São Paulo',
        },
        {
            name: 'Águas Vermelhas',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Águas de Lindóia',
            subdivision: 'São Paulo',
        },
        {
            name: 'Aguaí',
            subdivision: 'São Paulo',
        },
        {
            name: 'Adamantina',
            subdivision: 'São Paulo',
        },
        {
            name: 'Abaeté',
            subdivision: 'Minas Gerais',
        },
        {
            name: 'Guaíba',
            subdivision: 'Rio Grande do Sul',
        },
        {
            name: 'Palmas',
            subdivision: 'Tocantins',
        },
        {
            name: 'Tefé',
            subdivision: 'Amazonas',
        },
        {
            name: 'Tarauacá',
            subdivision: 'Acre',
        },
        {
            name: 'Tabatinga',
            subdivision: 'Amazonas',
        },
        {
            name: 'Sena Madureira',
            subdivision: 'Acre',
        },
        {
            name: 'São Gabriel da Cachoeira',
            subdivision: 'Amazonas',
        },
        {
            name: 'Rio Branco',
            subdivision: 'Acre',
        },
        {
            name: 'Porto Velho',
            subdivision: 'Rondônia',
        },
        {
            name: 'Manaus',
            subdivision: 'Amazonas',
        },
        {
            name: 'Manacapuru',
            subdivision: 'Amazonas',
        },
        {
            name: 'Humaitá',
            subdivision: 'Amazonas',
        },
        {
            name: 'Fonte Boa',
            subdivision: 'Amazonas',
        },
        {
            name: 'Eirunepé',
            subdivision: 'Amazonas',
        },
        {
            name: 'Cruzeiro do Sul',
            subdivision: 'Acre',
        },
        {
            name: 'Coari',
            subdivision: 'Amazonas',
        },
        {
            name: 'Carauari',
            subdivision: 'Amazonas',
        },
        {
            name: 'Boa Vista',
            subdivision: 'Roraima',
        },
        {
            name: 'Ariquemes',
            subdivision: 'Rondônia',
        },
        {
            name: 'Aripuanã',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Vilhena',
            subdivision: 'Rondônia',
        },
        {
            name: 'Pôsto Fiscal Rolim de Moura',
            subdivision: 'Rondônia',
        },
        {
            name: 'Pimenta Bueno',
            subdivision: 'Rondônia',
        },
        {
            name: 'Ouro Preto do Oeste',
            subdivision: 'Rondônia',
        },
        {
            name: 'Ji Paraná',
            subdivision: 'Rondônia',
        },
        {
            name: 'Jaru',
            subdivision: 'Rondônia',
        },
        {
            name: 'Guajará Mirim',
            subdivision: 'Rondônia',
        },
        {
            name: 'Cacoal',
            subdivision: 'Rondônia',
        },
        {
            name: 'Aparecida de Goiânia',
            subdivision: 'Goiás',
        },
        {
            name: 'Campinas',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Jaboatão dos Guararapes',
            subdivision: 'Pernambuco',
        },
        {
            name: 'Lauro de Freitas',
            subdivision: 'Bahia',
        },
        {
            name: 'Pinhais',
            subdivision: 'Paraná',
        },
        {
            name: 'Rio Preto da Eva',
            subdivision: 'Amazonas',
        },
        {
            name: 'Simões Filho',
            subdivision: 'Bahia',
        },
        {
            name: 'Sinop',
            subdivision: 'Mato Grosso',
        },
        {
            name: 'Cambebba',
            subdivision: 'Ceará',
        },
        {
            name: 'Trindade',
            subdivision: 'Santa Catarina',
        },
        {
            name: 'Freguesia do Ribeirao da Ilha',
            subdivision: 'Santa Catarina',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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